import { FooterResponseProps } from '@/blocks/Footer/types';
import { HeaderStrapiProps } from '@/features/Header/transformer';
import { ApiCallStrapiProps } from '@/utils/fetch';
import { getEntries } from '..';
import { Entry, GetPageResult } from '../types';
import { getPage } from './getPage';
import { tags } from './tags';
import { IS_VISUAL_TEST, visualTestFixtures } from './visualTestFixtures';

export const cms = {
  getBlogBySlug: (
    slug: string,
    status?: ApiCallStrapiProps['status'],
    fetchOptions?: ApiCallStrapiProps['fetchOptions'],
    envBridgeOptions?: ApiCallStrapiProps['envBridgeOptions']
  ) => {
    if (IS_VISUAL_TEST) return visualTestFixtures['/blogs'](slug);

    return getPage<Entry>({
      apiPath: '/blogs',
      slug,
      tags: [tags.blogBySlug(slug)],
      status,
      fetchOptions,
      envBridgeOptions,
    });
  },

  getPageBySlug: (
    slug: string,
    status?: ApiCallStrapiProps['status'],
    fetchOptions?: ApiCallStrapiProps['fetchOptions'],
    envBridgeOptions?: ApiCallStrapiProps['envBridgeOptions']
  ) =>
    getPage<Entry>({
      apiPath: '/pages',
      slug,
      tags: [tags.pageBySlug(slug)],
      status,
      fetchOptions,
      envBridgeOptions,
    }),

  getTopicBySlug: (
    slug: string,
    status?: ApiCallStrapiProps['status'],
    fetchOptions?: ApiCallStrapiProps['fetchOptions'],
    envBridgeOptions?: ApiCallStrapiProps['envBridgeOptions']
  ) =>
    getPage<Entry>({
      apiPath: '/blog-topics',
      slug,
      tags: [tags.blogTopicBySlug(slug)],
      status,
      fetchOptions,
      envBridgeOptions,
    }),

  getHeaderByDocumentId: (
    documentId: string,
    status?: ApiCallStrapiProps['status'],
    fetchOptions?: ApiCallStrapiProps['fetchOptions'],
    envBridgeOptions?: ApiCallStrapiProps['envBridgeOptions']
  ): Promise<GetPageResult<HeaderStrapiProps>> => {
    if (IS_VISUAL_TEST) return visualTestFixtures['/headers']();

    return getPage<Entry>({
      apiPath: '/headers',
      documentId,
      tags: [tags.headerByDocId(documentId)],
      status,
      fetchOptions,
      envBridgeOptions,
    });
  },

  getFooterByDocumentId: (
    documentId: string,
    status?: ApiCallStrapiProps['status'],
    fetchOptions?: ApiCallStrapiProps['fetchOptions'],
    envBridgeOptions?: ApiCallStrapiProps['envBridgeOptions']
  ): Promise<GetPageResult<FooterResponseProps>> => {
    if (IS_VISUAL_TEST) return visualTestFixtures['/footers']();

    return getPage<Entry>({
      apiPath: '/footers',
      documentId,
      tags: [tags.footerByDocId(documentId)],
      status,
      fetchOptions,
      envBridgeOptions,
    });
  },

  getLatestBlogpost: () => {
    if (IS_VISUAL_TEST) return visualTestFixtures['/blogs/latest']();

    return getEntries<Entry>({
      apiPath: '/blogs',
      query: {
        pLevel: '1',
        sort: 'metadata.releaseDate:desc',
        pagination: {
          start: 0,
          limit: 1,
        },
      },
      next: {
        tags: ['blogs', 'latest-blogpost'],
      },
    });
  },
};
